// src/components/public/layout/PublicNavLinks.tsx
'use client'
import React from 'react'

interface NavLink {
  label: string
  url: string
  openInNewTab?: boolean
}

interface PublicNavLinksProps {
  customLinks?: NavLink[] | null
}

/**
 * Renders any custom navbar links from branding.publicSite.navigation.customLinks.
 * Desktop only — the mobile navbar is intentionally minimal (logo + account +
 * cart). Renders nothing when there are no custom links.
 */
export function PublicNavLinks({ customLinks }: PublicNavLinksProps) {
  const all = Array.isArray(customLinks)
    ? customLinks.filter((l) => l && typeof l.label === 'string' && l.label.trim() && typeof l.url === 'string' && l.url.trim())
    : []

  if (all.length === 0) return null

  return (
    <div className="hidden md:flex items-center gap-1">
      {all.map((link, i) => (
        <a
          key={`${link.url}-${i}`}
          href={link.url}
          {...(link.openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          className="px-3 py-1.5 text-sm font-medium text-text-secondary hover:text-text-primary hover:bg-surface-tertiary rounded-lg transition-colors"
        >
          {link.label}
        </a>
      ))}
    </div>
  )
}

export default PublicNavLinks
